/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FileReadOnly } from "./FileReadOnly";
import {
  FileReadOnlyFromJSON,
  FileReadOnlyFromJSONTyped,
  FileReadOnlyToJSON,
  FileReadOnlyToJSONTyped,
} from "./FileReadOnly";
import type { UnitEnum } from "./UnitEnum";
import {
  UnitEnumFromJSON,
  UnitEnumFromJSONTyped,
  UnitEnumToJSON,
  UnitEnumToJSONTyped,
} from "./UnitEnum";
import type { Extent } from "./Extent";
import { ExtentFromJSON, ExtentFromJSONTyped, ExtentToJSON, ExtentToJSONTyped } from "./Extent";
import type { RasterTypeEnum } from "./RasterTypeEnum";
import {
  RasterTypeEnumFromJSON,
  RasterTypeEnumFromJSONTyped,
  RasterTypeEnumToJSON,
  RasterTypeEnumToJSONTyped,
} from "./RasterTypeEnum";

/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface Raster
 */
export interface Raster {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  type: RasterTypeEnum;
  /**
   *
   */
  readonly threedimodel?: string | null;
  /**
   *
   */
  name: string;
  /**
   *
   */
  readonly file?: FileReadOnly;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  epsgCode?: number | null;
  /**
   *
   */
  extent?: Extent;
  /**
   *
   */
  geotransform?: Array<number> | null;
  /**
   *
   */
  unit?: UnitEnum;
}

/**
 * Check if a given object implements the Raster interface.
 */
export function instanceOfRaster(value: object): value is Raster {
  if (!("type" in value) || value["type"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function RasterFromJSON(json: any): Raster {
  return RasterFromJSONTyped(json, false);
}

export function RasterFromJSONTyped(json: any, ignoreDiscriminator: boolean): Raster {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    type: RasterTypeEnumFromJSON(json["type"]),
    threedimodel:
      json["threedimodel"] === undefined
        ? undefined
        : json["threedimodel"] === null
        ? null
        : json["threedimodel"],
    name: json["name"],
    file: json["file"] == null ? undefined : FileReadOnlyFromJSON(json["file"]),
    id: json["id"] == null ? undefined : json["id"],
    epsgCode:
      json["epsg_code"] === undefined
        ? undefined
        : json["epsg_code"] === null
        ? null
        : json["epsg_code"],
    extent: json["extent"] == null ? undefined : ExtentFromJSON(json["extent"]),
    geotransform:
      json["geotransform"] === undefined
        ? undefined
        : json["geotransform"] === null
        ? null
        : json["geotransform"],
    unit: json["unit"] == null ? undefined : UnitEnumFromJSON(json["unit"]),
  };
}

export function RasterToJSON(json: any): Raster {
  return RasterToJSONTyped(json, false);
}

export function RasterToJSONTyped(
  value?: Omit<Raster, "url" | "threedimodel" | "file" | "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    type: RasterTypeEnumToJSON(value["type"]),
    name: value["name"],
    epsg_code: value["epsgCode"],
    extent: ExtentToJSON(value["extent"]),
    geotransform: value["geotransform"],
    unit: UnitEnumToJSON(value["unit"]),
  };
}
